export default "__VITE_ASSET__D85bF4D7__"